import { createSelector } from "@reduxjs/toolkit";

export const selectQrCostCalculation = createSelector(
  state => state.marketplace.qrCode,
  qrCode => ({ couponCode: qrCode.couponCode, ...qrCode.calculation })
);
